export default {
  name: "Landing",
  path: "/",
  component: () => import("@/views/Landing"),
  meta: {
    // Public marketing page: skip all auth/maintenance middleware.
    middleware_excemption: true
  }
};
